export function TrashIcon({ color, size = 24 }: { color?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.25 4.5h-4.5V3.38a1.87 1.87 0 0 0-1.87-1.88h-3.76a1.9 1.9 0 0 0-1.87 1.88V4.5h-4.5a.75.75 0 0 0 0 1.5h.8l.89 14.3a2.26 2.26 0 0 0 2.25 2.2h8.62c1.23 0 2.17-.93 2.25-2.2l.9-14.3h.79a.75.75 0 1 0 0-1.5m-11.22 15H9a.75.75 0 0 1-.75-.72l-.37-10.5a.75.75 0 0 1 1.5-.06l.37 10.5a.75.75 0 0 1-.72.78m3.72-.75a.75.75 0 1 1-1.5 0V8.25a.75.75 0 1 1 1.5 0zm1.5-14.25h-4.5V3.38a.37.37 0 0 1 .38-.38h3.74a.37.37 0 0 1 .38.38zm1.5 14.28a.75.75 0 0 1-.75.72h-.03a.75.75 0 0 1-.72-.78l.38-10.5a.75.75 0 0 1 1.5.06z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
